export const COLOR = {
    PRIMARY: '#1F8DDD',
    LINK: '#4BCAE5'
};
